module.exports = __webpack_public_path__ + "img/page40.c59ad335.gif";